import { useQuery } from "react-query";
import axios from "axios";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil";
import { Loader } from "../../components/Loader";
import { useEffect, useState } from "react";
import RestaurantInvoice from "../../components/restaurant/invoice";
import { Cashier } from "../../types/restaurant";
import { Button } from "../../components/Button";

const RestaurantCashiers = () => {
  const auth = useRecoilValue(authState);
  const [selectedCashier, setSelectedCashier] = useState<Cashier | null>(null);

  const {
    data: cashiers,
    isLoading: isCashiersLoading,
    refetch,
  } = useQuery(
    "Get Restaurant Cashiers",
    async () => {
      const response = await axios.get(`/restaurant/devices/${auth?.branchId}`);
      return response.data.devices;
    },
    { enabled: !!auth?.branchId, retry: 1, refetchOnWindowFocus: false }
  );

  const { data: invoice, isLoading: isInvoiceLoading } = useQuery(
    "Get Invoice",
    async () => {
      const response = await axios.get("/order/foodics/cashier/last-order", {
        params: {
          restaurantId: auth?.restaurantId,
          casherId: selectedCashier?.device_id || "",
        },
      });
      return response.data.invoice;
    },
    {
      enabled: !!selectedCashier?.device_id,
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    document.title = "Specter | Cashiers";
  }, []);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  if (isCashiersLoading || isInvoiceLoading) {
    return (
      <div className="flex justify-center items-center pt-32">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {selectedCashier ? (
        <div className="flex flex-col items-center mt-10">
          <div className="flex flex-wrap items-center justify-between mb-4 w-full">
            <Button lightBlue onClick={() => setSelectedCashier(null)}>
              Back to Cashiers
            </Button>
            <h2 className="text-2xl font-bold">
              Last Order for{" "}
              <span className="text-primary">{selectedCashier.name}</span>
            </h2>
            <div className="w-40"></div>
          </div>
          <p className="font-bold text-lg mb-6">
            Branch :{" "}
            <span className="text-primary font-bold">
              {selectedCashier.branch.name}
            </span>
          </p>
          <RestaurantInvoice
            invoice={invoice}
            type="cashier"
            restaurantId={auth?.restaurantId || 0}
            cashierId={selectedCashier.device_id}
            setSelectedCashier={setSelectedCashier}
          />
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <p className="col-span-3 text-xl font-bold select-none">
            Get Last Order and Save to User
          </p>
          {cashiers?.map((cashier: Cashier) => (
            <div
              key={cashier?.id}
              className="bg-primary/20 text-xl text-primary min-h-20 font-bold border border-primary rounded-lg p-4 flex items-center justify-center cursor-pointer hover:bg-primary/30 transition-colors select-none"
              onClick={() => setSelectedCashier(cashier)}
            >
              <div className="flex flex-col items-center">
                <span>{cashier?.name}</span>
                <span className="text-sm text-muted">
                  {cashier?.branch?.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default RestaurantCashiers;
